/* istanbul ignore file */
import en from 'antd/lib/locale-provider/en_US';
import fr from 'antd/lib/locale-provider/fr_FR';

const antdLocales = { en, fr };
export default antdLocales;
